import Vue from 'vue'
// models component
import App from '@/models/App'
import Profile from '@/models/Profile'

export default class TokenVerify {
    // Token Verify
    static of() {
        if (Vue.$cookies.isKey('_t')) {
            // console.log('トークン認証を開始します profile.verify()')
            return Profile.api()
                .verify()
                .then(function (result) {
                    // console.log('Verify', Profile.one())
                    let token = Profile.one().token
                    App.setLogined(true)
                    App.setToken(token)
                    Vue.$cookies.set('_t', token, '30d')
                    const isLocked = localStorage.getItem(
                        `attendLock_${Profile.one().id}`
                    )
                    if (isLocked) {
                        return isLocked
                    }
                })
                .catch((error) => {
                    Vue.$cookies.remove('_t')
                    return new Promise((resolve, reject) => {
                        reject(new Error())
                    })
                })
        } else {
            return new Promise((resolve, reject) => {
                reject(new Error())
            })
        }
    }
}
